import axios from 'axios';
import apisUrls from '../urls';

const getAllSectionTitlesApi = (filterObj) => {
  return axios.get(apisUrls?.getSectiontitles(filterObj));
};

export default getAllSectionTitlesApi;
